import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, TrendingUp, Sparkles, Activity } from 'lucide-react';
export function FeatureCards() {
  const features = [{
    icon: Calendar,
    title: 'Daily Summaries',
    description: 'Start your day with a simple briefing. No complex charts, just what you need to know about your sleep and readiness.',
    color: 'bg-blue-50 text-blue-600'
  }, {
    icon: TrendingUp,
    title: 'Baseline Comparison',
    description: 'See how today compares to your 30-day average. Spot trends before they become problems.',
    color: 'bg-teal-50 text-teal-600'
  }, {
    icon: Sparkles,
    title: 'Simple Insights',
    description: "We translate 'HRV: 35ms' into 'Your body is under stress, prioritize rest today.'",
    color: 'bg-purple-50 text-purple-600'
  }];
  return <section className="py-24 bg-slate-50" data-id="element-26">
      <div className="container mx-auto px-4" data-id="element-27">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-29">
            What Vytaniq Delivers
          </h2>
          <p className="text-lg text-slate-600" data-id="element-30">
            We strip away the noise and focus on the signals that matter.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-31">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 hover:shadow-md transition-all duration-300" data-id="element-32">
              <div className={`h-14 w-14 rounded-xl flex items-center justify-center mb-6 ${feature.color}`} data-id="element-33">
                <feature.icon className="h-7 w-7" data-id="element-34" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-35">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-36">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}